var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location-6",
    transform: "translate(-588.686 -2143)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(588.686 2143)",
    fill: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5593",
    "data-name": "Trac\\xE9 5593",
    d: "M4.032.144A2.846,2.846,0,0,0,6.96-2.748a2.815,2.815,0,0,0-2.808-2.94,2.6,2.6,0,0,0-1.176.3H2.952A1.872,1.872,0,0,1,4.8-6.8a3.268,3.268,0,0,1,1.176.252l.564-1.8a4.327,4.327,0,0,0-1.9-.372C1.98-8.724.552-6.288.552-3.96.552-1.164,2.3.144,4.032.144Zm0-1.92a1.591,1.591,0,0,1-1.32-1.7c0-.4.408-.516.888-.516a1.2,1.2,0,0,1,1.3,1.26A.9.9,0,0,1,4.032-1.776Z",
    transform: "translate(592.603 2154.586)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation6);
export default __webpack_public_path__ + "static/media/location-6.1ffb279a815ad0fff766fd26e520216b.svg";
export { ForwardRef as ReactComponent };